// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinner":"LoadingSpinner_LoadingSpinner__2qZKd","LdsDualRing":"LoadingSpinner_LdsDualRing__2vZTS","lds-dual-ring":"LoadingSpinner_lds-dual-ring__pzPMC"};